import { classesBuilder } from '@common/helpers';

import type { ISubsectionProps } from './types';

import style from './styles.module.scss';

const Subsection = (props: ISubsectionProps) => {
  const { id, title, content, contentComponent, isVisible, refElement } = props;

  return (
    <div
      key={id}
      ref={refElement}
      className={classesBuilder(style.subsection, isVisible ? style.visible : style.skeleton)}
    >
      {title && <h2>{title}</h2>}

      {contentComponent ?? <div>{content}</div>}
    </div>
  );
};

export default Subsection;
